export default function() {
	const debug = false; // Enable debug logs

	function executeModalDOM(evt) {
		let isModalOpen = false;
		const playButtons = document.querySelectorAll('.js-modal-generic-play');

		const modal = document.getElementById('js-modal-generic');
		const modalClose = modal.querySelector('#js-modal-generic-close');
		const modalContent = modal.querySelector('#js-modal-generic-content');
		const modalVideoContainer = modal.querySelector('.modal-generic__video-container');
		const modalContentContainer = modal.querySelector('.modal-generic__video-content');
		const modalTitle = modal.querySelector('.modal-generic__video-title');
		const modalDescription = modal.querySelector('.modal-generic__video-description');

		playButtons.forEach(button => {
			let siblingElement = button.nextSibling;

			// Traverse through siblings until an element node is found
			while (siblingElement && siblingElement.nodeType !== 1) {
				siblingElement = siblingElement.nextSibling;
			}

			if (siblingElement) {
				debug ? console.log('Initial sibling element found: ', siblingElement) : false;

				// Function to handle the content blocker when it's found
				const handleContentBlocker = (element) => {
					debug ? console.log('Content blocker found and handled: ', element) : false;

					element.style.opacity = '0';
					element.style.height = '0';

					// Polling function to repeatedly check for the anchor
					const pollForAnchor = () => {
						const anchor = element.querySelector('a');
						if (anchor) {
							debug ? console.log('Anchor found within content blocker') : false;

							button.addEventListener('click', function() {
								debug ? console.log('Play button clicked, triggering anchor in content blocker') : false;
								anchor.click(); // Simulate a click on the anchor within the rcb-content-blocker element
							});
						} else {
							debug ? console.log('Anchor not found, retrying...') : false;
							setTimeout(pollForAnchor, 100); // Retry after 100ms
						}
					};

					// Start polling for the anchor
					pollForAnchor();
				};

				// Check if the content blocker is already present
				if (siblingElement.classList.contains('rcb-content-blocker')) {
					handleContentBlocker(siblingElement);
				} else {
					debug ? console.log('Content blocker not found initially, setting up observer...') : false;

					// Observe changes to the sibling element to catch the dynamically added content
					const observer = new MutationObserver(mutations => {
						mutations.forEach(mutation => {
							mutation.addedNodes.forEach(node => {
								if (node.nodeType === 1 && node.classList.contains('rcb-content-blocker')) {
									handleContentBlocker(node);
									observer.disconnect(); // Stop observing after handling
								}
							});
						});
					});

					// Start observing the nearest parent container for changes
					const closestContainer = button.closest('.js-modal-generic-play').parentElement;
					if (closestContainer) {
						observer.observe(closestContainer, { childList: true, subtree: true });
					}
				}
			} else {
				debug ? console.log('No valid sibling element found.') : false;
			}

			// Restore original click event handling for the button
			button.addEventListener('click', handleClickPlayVideo);
		});

		if (modalClose) {
			modalClose.addEventListener('click', handleClickCloseVideo);
		}

		function handleClickPlayVideo(evt) {
			evt.preventDefault();
			debug ? console.log('handleClickPlayVideo') : false;

			const nextElement = this.nextElementSibling;

			// Handle the case where the iframe is directly present (consent granted)
			if (nextElement && nextElement.classList.contains('js-modal-generic-iframe')) {
				debug ? console.log('Open the modal with iframe...') : false;

				let content = nextElement.innerHTML.trim();

				if (content.startsWith('<!-- ')) {
					content = content.substring('<!-- '.length);
				}
				if (content.endsWith(' -->')) {
					content = content.substring(0, content.length - ' -->'.length);
				}

				modalVideoContainer.innerHTML = content;
				modal.style.display = 'block';
				document.documentElement.classList.add('modal-is-open');

				setTimeout(() => {
					modal.classList.add('active');
					isModalOpen = true;
					document.addEventListener('click', handleOutsideClick);
				}, 100);

				const dataTitle = this.getAttribute('data-modal-title');
				const dataDescription = this.getAttribute('data-modal-description');

				if (!dataTitle && !dataDescription) {
					modalVideoContainer.classList.add('rounded');
					modalContent.classList.add('hidden');
				} else {
					modalVideoContainer.classList.remove('rounded');
					modalContent.classList.remove('hidden');
				}

				if (dataTitle) {
					modalTitle.innerHTML = dataTitle;
				}
				if (dataDescription) {
					modalDescription.innerHTML = dataDescription;
				}
			}
		}

		function handleClickCloseVideo(evt) {
			evt.preventDefault();
			debug ? console.log('handleClickCloseVideo') : false;

			modal.classList.remove('active');
			modalVideoContainer.innerHTML = '';
			modalTitle.innerHTML = '';
			modalDescription.innerHTML = '';

			setTimeout(() => {
				modal.style.display = 'none';
				document.documentElement.classList.remove('modal-is-open');
				isModalOpen = false;
				document.removeEventListener('click', handleOutsideClick);
			}, 300);
		}

		function handleOutsideClick(evt) {
			if (isModalOpen && modalTitle !== evt.target && modalDescription !== evt.target && modalContentContainer !== evt.target) {
				debug ? console.log('User clicked outside the modal while it was open') : false;
				handleClickCloseVideo(evt);
			}
		}
	}

	document.addEventListener('filtersApplied', () => {
		executeModalDOM();
	});

	executeModalDOM();
}
